export { default as confirm } from './confirm';
export { default as GlobalConfirm } from './GlobalConfirm';
